<!-- From -->
<div class="col-md-4" [formGroup]="invoiceForm">
    <label class="form-label fw-bold required" for="">Company Details
        <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip"
            title="Company details are saved automatically after invoice creation."></i>
        
        @if(canAddCompany){
            <button type="button" class="btn btn-link" (click)="addCompanyDetails()">
                Add Company <i class="bi bi-plus-square-fill"></i>
            </button>
        }@else {
            <button type="button" class="btn btn-link-primary" (click)="onPremiumAddCompanyClick()">
                Add Company <i class="bi bi-star-fill"></i>
            </button>
        }
    </label>

    <!-- Dropdown with companies list if user have more than one company-->
    @if(companies.length > 0){
        <select class="form-select mb-2" (change)="onCompanySelect($event)">
            <option value="">Select Existing Company</option>
            @for(company of companies; track company.id){
                <option [value]="company.id">{{ company.name }}</option>
            }
        </select>
    }

    @if(showCompanyForm()){
        <input type="text" class="form-control mb-1" placeholder="Name*" formControlName="companyName"
            [class.is-invalid]="invoiceForm.get('companyName')?.invalid && invoiceForm.get('companyName')?.touched"
            [attr.title]="invoiceForm.get('companyName')?.hasError('required') && invoiceForm.get('companyName')?.touched ? 'Company Name is required' : null"
            data-bs-toggle="tooltip" >

        <input type="text" class="form-control mb-1" placeholder="Address*" formControlName="companyAddress"
            [class.is-invalid]="invoiceForm.get('companyAddress')?.invalid && invoiceForm.get('companyAddress')?.touched"
            [attr.title]="invoiceForm.get('companyAddress')?.hasError('required') && invoiceForm.get('companyAddress')?.touched ? 'Company Address is required' : null"
            data-bs-toggle="tooltip" >

        <input type="text" class="form-control mb-1" placeholder="City*" formControlName="companyCity"
            [class.is-invalid]="invoiceForm.get('companyCity')?.invalid && invoiceForm.get('companyCity')?.touched"
            [attr.title]="invoiceForm.get('companyCity')?.hasError('required') && invoiceForm.get('companyCity')?.touched ? 'Company City is required' : null"
            data-bs-toggle="tooltip" >

        <input type="text" class="form-control mb-1" placeholder="Province/State*" formControlName="companyProvince"
            [class.is-invalid]="invoiceForm.get('companyProvince')?.invalid && invoiceForm.get('companyProvince')?.touched"
            [attr.title]="invoiceForm.get('companyProvince')?.hasError('required') && invoiceForm.get('companyProvince')?.touched ? 'Company Province is required' : null"
            data-bs-toggle="tooltip" >

        <input type="text" class="form-control mb-1" placeholder="Postal/Zip Code*" formControlName="companyPostalCode"
            [class.is-invalid]="invoiceForm.get('companyPostalCode')?.invalid && invoiceForm.get('companyPostalCode')?.touched"
            [attr.title]="invoiceForm.get('companyPostalCode')?.hasError('required') && invoiceForm.get('companyPostalCode')?.touched ? 'Company Postal Code is required' : null"
            data-bs-toggle="tooltip">

        <select class="form-select mb-1" formControlName="companyCountry"
            (change)="onCompanyCountryChange(invoiceForm.get('companyCountry')?.value)"
            [class.is-invalid]="invoiceForm.get('companyCountry')?.invalid && invoiceForm.get('companyCountry')?.touched"
            [attr.title]="invoiceForm.get('companyCountry')?.hasError('required') && invoiceForm.get('companyCountry')?.touched ? 'Company Country is required' : null"
            data-bs-toggle="tooltip">

            <option value="">Select Country</option>
            @for (country of countries; track country) {
                <option [value]="country">{{ country }}</option>
            }

        </select>
    }
</div>
<!-- End From -->

<!-- Tax/Other Details -->
<div class="col-md-4" [formGroup]="invoiceForm">
    @if(showCompanyForm()){
        <label class="form-label fw-bold" for="">Tax/Other Details</label>

        <div class="form-check mb-3">
            <input type="checkbox" class="form-check-input mb-2" formControlName="taxEnabled"
                (change)="toggleGSTHSTInput()">

            <label class="form-check-label" for="checkDefault">
                GST/HST Enabled?
            </label>
        </div>

        <input type="text" class="form-control mb-1" placeholder="GST Number" formControlName="gstNumber"
            [class.is-invalid]="invoiceForm.get('gstNumber')?.invalid && invoiceForm.get('gstNumber')?.touched"
            [attr.title]="invoiceForm.get('gstNumber')?.hasError('required') && invoiceForm.get('gstNumber')?.touched ? 'GST Number is required' : null"
            data-bs-toggle="tooltip">

        <input type="text" class="form-control mb-1" placeholder="HST Number" formControlName="hstNumber"
            [class.is-invalid]="invoiceForm.get('hstNumber')?.invalid && invoiceForm.get('hstNumber')?.touched"
            [attr.title]="invoiceForm.get('hstNumber')?.hasError('required') && invoiceForm.get('hstNumber')?.touched ? 'HST Number is required' : null"
            data-bs-toggle="tooltip">

        <input type="tel" class="form-control mb-1" placeholder="Phone" formControlName="companyPhone">

        <input type="text" class="form-control mb-1" placeholder="Website Link" formControlName="websiteLink">

        <select class="form-select mb-1" formControlName="companyCurrency"
            [class.is-invalid]="invoiceForm.get('companyCurrency')?.invalid && invoiceForm.get('companyCurrency')?.touched"
            [attr.title]="invoiceForm.get('companyCurrency')?.hasError('required') && invoiceForm.get('companyCurrency')?.touched ? 'Company Currency is required' : null"
            data-bs-toggle="tooltip">

            <option value="" selected>Select Currency</option>
            <option value="CAD">CAD - Canadian Dollar</option>
            <option value="USD">USD - US Dollar</option>
            <option value="INR">INR - Indian Rupee</option>
            <option value="EUR">EUR - Euro</option>
            <option value="GBP">GBP - British Pound</option>

        </select>
    }
</div>
<!-- End Tax/Other Details -->